import {connect} from '@store/@common';
import KpiTargetSource from '@store/kpi/KpiTargetSource';

import {AssignToField} from './assign-to.field';
import {hasKpiAssigned} from '@store/kpi';

const mapStateToProps = {
  hasKpiAssigned,
};

const mapActionsToProps = {
  fullSource: KpiTargetSource.assigneeAutocomplete,
  commonSource: KpiTargetSource.assigneeAutocompleteCommon,
};

export default connect(AssignToField, mapStateToProps, mapActionsToProps);
